import { Info, Download } from 'lucide-react';
import { useState } from 'react';
import chepLogo from '../../assets/images/CHEP_Logo.png';
import { Button } from '../ui/button';
import { ResourcesDialog } from './ResourcesDialog';

export function Header() {
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);

  const handleDownloadDocument = (documentType: 'framework' | 'scope3') => {
    // Create mock CSV content for the documents
    let csvContent = '';
    let filename = '';

    if (documentType === 'framework') {
      filename = 'Differentiation_Framework_Statements.csv';
      csvContent = `Category,Statement,Description
Circular Economy,CHEP Platform Excellence,"P&G leverages CHEP's pooling platform to eliminate single-use packaging and reduce supply chain waste"
Supply Chain Innovation,Collaborative Logistics,"Partnership enables shared transportation networks and optimized distribution routes"
Environmental Impact,Carbon Reduction Leadership,"Integrated approach delivers measurable reductions in Scope 3 emissions through circular practices"
Operational Efficiency,Cycle Time Optimization,"Streamlined processes reduce production cycles while maintaining quality and sustainability standards"
Sustainability Leadership,Extended Producer Responsibility,"Joint commitment to EPR principles and circular economy implementation across the value chain"`;
    } else {
      filename = 'Scope_3_Emission_Factors_for_Reporting.csv';
      csvContent = `Category,Emission Factor,Unit,Source,Notes
Reusable Pallets (CHEP),1.8,kg CO₂e per pallet cycle,GHG Protocol,Includes production and end-of-life avoided emissions
Transport Collaboration,1.2,kg CO₂e per ton-km,EPA SmartWay,Shared logistics network optimization
Supplier Integration,3.0,kg CO₂e per supplier touchpoint,ISO 14064,Supply chain coordination and efficiency gains
Cycle Time Reduction,0.8,kg CO₂e per day saved,Industry Average,Production efficiency improvements
Waste to CO₂ Conversion,2.0,kg CO₂e per kg waste avoided,DEFRA Guidelines,General waste avoided emissions factor
Trees Saved Conversion,0.05,trees per tCO₂e,Forest Service Data,Average tree carbon sequestration equivalency`;
    }

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      {/* Blue Top Bar */}
      <div className="h-2 bg-[#0251bf]" />

      {/* Header Content */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-[1600px] mx-auto px-8 py-6">
          <div className="flex justify-between gap-8">
            {/* Logo and Title Section */}
            <div className="flex items-center gap-6">
              {/* Logo */}
              <img
                src={chepLogo}
                alt="CHEP Logo"
                className="h-12 w-auto object-contain flex-shrink-0"
              />

              {/* Title */}
              <div className="border-l border-gray-300 pl-6">
                <h1 className="text-[#0072CE] mb-2">Circular Impact Dashboard</h1>
                <div className="flex items-center gap-2">
                  {/* Joe's Donuts Logo */}
                  <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full shadow-sm">
                    <span className="text-white text-lg">🍩</span>
                  </div>
                  <p className="text-gray-600">Joe's Donuts Executive Report</p>
                </div>
              </div>
            </div>

            {/* Right Section: Buttons and Info */}
            <div className="flex items-start gap-4">
              {/* Info Section */}
              <div className="flex items-start gap-3 max-w-xl bg-blue-50 border border-blue-200 rounded-lg p-4">
                <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm text-gray-700">
                    <strong>How to use:</strong> Hover over bars to see details. Click on any bar to edit values and simulate different scenarios.
                    Toggle between metrics to see impact across CO₂e, waste reduction, and trees saved equivalents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Resources Dialog */}
      <ResourcesDialog
        isOpen={isResourcesOpen}
        onClose={() => setIsResourcesOpen(false)}
        onDownloadDocument={handleDownloadDocument}
      />
    </div>
  );
}
